import * as React from "react";
import styled from "styled-components";
import { IconButton, Tooltip } from "@material-ui/core";
import { ReactComponent as DownloadSvg } from "../../../../assets/downloadIcon.svg";
import { DownloadType } from "./types";


interface AdInformationProps {
  adId: string;
  title: string;
  description: string;
  adDuration: number;
  onDownload: (type: DownloadType) => void; 
}

export const AdInformation: React.FC<AdInformationProps> = ({
  adId,
  title,
  description,
  adDuration,
  onDownload,
}) => {
  return (
    <StyledInfoContainer>
      <StyledInfoContent>
        <Tooltip title="Download comercial" arrow>
          <DownloadBtn size="small" onClick={() => onDownload('creative')}>
            <DownloadSvg width={28} height={28} style={{ marginRight: '8px' }}/>
          </DownloadBtn>
        </Tooltip>
        <LabelRow>
          <Label>ID:</Label>
          <Value>{adId}</Value>
        </LabelRow>
        <Hr />
        <LabelRow>
          <Label>Título:</Label>
          <Tooltip title={title} aria-label={title} arrow>
            <Value>{title}</Value>
          </Tooltip>
        </LabelRow>
        <Hr />
        <LabelRow>
          <Label>Descrição:</Label>
          <Tooltip title={description} aria-label={description} arrow>
            <Value>{description}</Value>
          </Tooltip>
        </LabelRow>
        <Hr />
        <LabelRow>
          <Label>Duração AD:</Label>
          <Value>{adDuration}s</Value>
        </LabelRow>
      </StyledInfoContent>
    </StyledInfoContainer>
  );
};

// Estilos
const StyledInfoContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  background-color: #d9d9d9;
  border-radius: 3px 3px 0 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-family: "Roboto", "Montserrat";
  height: 210px;
`;

const StyledInfoContent = styled.div`
  display: grid;
  grid-template-columns: min-content;
  /*gap: 8px 16px;*/
  width: 100%;
  max-width: 600px;
  background: #d9d9d9;
  padding: 16px;
  font-family: "Roboto", "Montserrat";
`;

const LabelRow = styled.div`
  display: contents;
`;

const Label = styled.div`
  font-weight: bold;
  color: #5b5b5b;
  width: 125px;
  padding: 8px 0px;
`;

const Value = styled.div`
  color: #5b5b5b;
  text-overflow: ellipsis;
  padding: 8px 0px;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  height: 40px;
`;

const Hr = styled.div`
  grid-column: span 2;
  border-bottom: 1px solid #b1b1b1;
  margin: 1px 0;
`;

export const DownloadBtn = styled(IconButton)`
  && {
    position: absolute;
    top: 4px;
    right: 4px;
    padding: 6px;
    color: #5b5b5b;
    background: transparent;

    svg {
      width: 24px;
      height: 24px;
      fill: currentColor;
    }
  }
`;
